import emailjs from "@emailjs/browser";
import { supabase } from "../lib/supabase";
import { useState, useEffect, useRef } from "react";
import "../styles/chatbot.css";

const WHATSAPP_NUMBER = "919970774674";

export default function Chatbot() {
  const [isOpen, setIsOpen] = useState(false);

  const [leadData, setLeadData] = useState({
    service: "",
    projectType: "",
    budget: "",
    timeline: "",
    name: "",
    phone: "",
    email: "",
    notes: ""
  });

  const [step, setStep] = useState("welcome");
  const [input, setInput] = useState("");

  const [messages, setMessages] = useState([
    {
      sender: "bot",
      text:
        "👋 Welcome to Ideas On Work!\n\nI'm here to understand your requirements and help you get started."
    }
  ]);

  const messagesEndRef = useRef(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({
      behavior: "smooth"
    });
  }, [messages]);

  const serviceOptions = [
    "Website Development",
    "AI Chatbot",
    "CRM Solution",
    "Business Email"
  ];

  const projectOptions = [
    "Business Website",
    "Ecommerce Store",
    "Portfolio Website",
    "Custom Web Application"
  ];

  const budgetOptions = [
    "Under ₹25,000",
    "₹25,000 - ₹50,000",
    "₹50,000 - ₹1,00,000",
    "Above ₹1,00,000"
  ];

  const timelineOptions = [
    "Immediately",
    "Within 1 Month",
    "Within 3 Months",
    "Just Exploring"
  ];

  function addBotMessage(text) {
    setMessages(prev => [
      ...prev,
      {
        sender: "bot",
        text
      }
    ]);
  }

  function addUserMessage(text) {
    setMessages(prev => [
      ...prev,
      {
        sender: "user",
        text
      }
    ]);
  }

  async function sendLeadEmail(data) {
    try {
//// HERE STARTS
        //   console.log("sendLeadEmail called");
        //   console.log(process.env.REACT_APP_EMAILJS_SERVICE_ID);
        //   console.log(process.env.REACT_APP_EMAILJS_TEMPLATE_ID);
        //   console.log(process.env.REACT_APP_EMAILJS_PUBLIC_KEY);
//// HERE ENDS

    //   const response = await emailjs.send(
    await emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        {
          from_name: data.name,
          service: data.service,
          projectType: data.projectType,
          budget: data.budget,
          timeline: data.timeline,
          name: data.name,
          phone: data.phone,
          email: data.email,
          notes: data.notes,
          time: new Date().toLocaleString()
        },
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      );

    //   console.log(
    //     "Email sent successfully",
    //     response
    //   );

      return true;
    } catch (error) {

        // console.error(
        //   "FULL EMAILJS ERROR:"
        // );

        // console.log(error);

        // console.log(
        //   JSON.stringify(error)
        // );

        return false;
      }
  }
  async function saveLeadToSupabase(data) {
  try {

    const { error } =
      await supabase
        .from("leads")
        .insert([
          {
            service:
              data.service,

            project_type:
              data.projectType,

            budget:
              data.budget,

            timeline:
              data.timeline,

            name:
              data.name,

            phone:
              data.phone,

            email:
              data.email,

            notes:
              data.notes
          }
        ]);

    if (error) {
      throw error;
    }

    return true;

  } catch (error) {

    console.error(
      "Supabase save failed",
      error
    );

    return false;
  }
  }
  function handleService(service) {
    addUserMessage(service);

    setLeadData(prev => ({
      ...prev,
      service
    }));

    setTimeout(() => {
      addBotMessage(
        "Great! What type of project are you looking for?"
      );

      setStep("projectType");
    }, 500);
  }

  function handleProjectType(projectType) {
    addUserMessage(projectType);

    setLeadData(prev => ({
      ...prev,
      projectType
    }));

    setTimeout(() => {
      addBotMessage(
        "What is your approximate budget?"
      );

      setStep("budget");
    }, 500);
  }

  function handleBudget(budget) {
    addUserMessage(budget);

    setLeadData(prev => ({
      ...prev,
      budget
    }));

    setTimeout(() => {
      addBotMessage(
        "When would you like the project completed?"
      );

      setStep("timeline");
    }, 500);
  }

  function handleTimeline(timeline) {
    addUserMessage(timeline);

    setLeadData(prev => ({
      ...prev,
      timeline
    }));

    setTimeout(() => {
      addBotMessage(
        "Please enter your name."
      );

      setStep("name");
    }, 500);
  }
  async function handleTextInput() {
    const value = input.trim();

    if (!value) return;

    addUserMessage(value);

    if (step === "name") {

      setLeadData(prev => ({
        ...prev,
        name: value
      }));

      setTimeout(() => {
        addBotMessage(
          "Please enter your phone number."
        );

        setStep("phone");
      }, 500);
    }

    else if (step === "phone") {

      setLeadData(prev => ({
        ...prev,
        phone: value
      }));

      setTimeout(() => {
        addBotMessage(
          "Please enter your email address."
        );

        setStep("email");
      }, 500);
    }

    else if (step === "email") {

      setLeadData(prev => ({
        ...prev,
        email: value
      }));

      setTimeout(() => {
        addBotMessage(
          "Any additional notes? (Optional)\n\nType your requirements or simply type 'skip'."
        );

        setStep("notes");
      }, 500);
    }

    else if (step === "notes") {

      const finalLead = {
        ...leadData,
        email: leadData.email,
        notes:
          value.toLowerCase() === "skip"
            ? ""
            : value
      };

      setLeadData(finalLead);

      addBotMessage(
        "Submitting your enquiry..."
      );

      /* const success =
        await sendLeadEmail(finalLead);

      if (success) {

        addBotMessage(
          "🎉 Thank you!\n\nWe've received your enquiry.\n\nWe'll review your requirements and contact you shortly."
        );

      } else {

        addBotMessage(
          "❌ Unable to submit enquiry.\n\nPlease contact us directly or try again later."
        );

      } */

      const emailSuccess =
  await sendLeadEmail(
    finalLead
  );

if (emailSuccess) {

  await saveLeadToSupabase(
    finalLead
  );

  addBotMessage(
    "🎉 Thank you!\n\nWe've received your enquiry.\n\nWe'll review your requirements and contact you shortly."
  );

} else {

  addBotMessage(
    "❌ Unable to submit enquiry.\n\nPlease try again later."
  );
}

      setStep("complete");
    }

    setInput("");
  }

  function renderOptions() {
    switch (step) {

      case "welcome":
        return serviceOptions;

      case "projectType":
        return projectOptions;

      case "budget":
        return budgetOptions;

      case "timeline":
        return timelineOptions;

      default:
        return [];
    }
  }

  function handleOptionClick(option) {

    switch (step) {

      case "welcome":
        handleService(option);
        break;

      case "projectType":
        handleProjectType(option);
        break;

      case "budget":
        handleBudget(option);
        break;

      case "timeline":
        handleTimeline(option);
        break;

      default:
        break;
    }
  }

  function restartConversation() {

    setLeadData({
      service: "",
      projectType: "",
      budget: "",
      timeline: "",
      name: "",
      phone: "",
      email: "",
      notes: ""
    });

    setMessages([
      {
        sender: "bot",
        text:
          "👋 Welcome to Ideas On Work!\n\nI'm here to understand your requirements and help you get started."
      }
    ]);

    setInput("");
    setStep("welcome");
  }

  return (
    <>
      {!isOpen && (
        <button
          className="chatbot-toggle"
          onClick={() => setIsOpen(true)}
        >
          💬
        </button>
      )}

      {isOpen && (
        <div className="chatbot-window">

          <div className="chatbot-header">
            <h4>AI Assistant</h4>

            <button
              className="chatbot-close"
              onClick={() => setIsOpen(false)}
            >
              ✖
            </button>
          </div>

          <div className="chatbot-messages">

            {messages.map((msg, index) => (
              <div
                key={index}
                className={`message ${
                  msg.sender === "user"
                    ? "user"
                    : "bot"
                }`}
              >
                <div
                  style={{
                    whiteSpace: "pre-line"
                  }}
                >
                  {msg.text}
                </div>
              </div>
            ))}
            {(step === "welcome" ||
              step === "projectType" ||
              step === "budget" ||
              step === "timeline") && (
              <div className="quick-questions">
                {renderOptions().map(
                  (option, index) => (
                    <div
                      key={index}
                      className="quick-question"
                      onClick={() =>
                        handleOptionClick(option)
                      }
                    >
                      {option}
                    </div>
                  )
                )}
              </div>
            )}
            {step === "complete" && (
                <div className="quick-questions">

                    <div
                    className="quick-question"
                    onClick={() => {
                        // const message =
                        // "Hello Ideas On Work, I have just submitted an enquiry through your website and would like to discuss my requirements.";
                            const message =
                            `Hello Ideas On Work, I am ${leadData.name}. I have just submitted an enquiry through your website and would like to discuss my requirements.`;

                        window.open(
                        `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`,
                        "_blank"
                        );
                    }}
                    >
                    Chat on WhatsApp
                    </div>

                    <div
                    className="quick-question"
                    onClick={restartConversation}
                    >
                    Start New Enquiry
                    </div>

                </div>
                )}
            {/* {step === "complete" && (
              <div className="quick-questions">

                <div
                  className="quick-question"
                  onClick={
                    restartConversation
                  }
                >
                  Start New Enquiry
                </div>

              </div>
            )} */}

            <div ref={messagesEndRef}></div>

          </div>

          {(step === "name" ||
            step === "phone" ||
            step === "email" ||
            step === "notes") && (
            <div className="chatbot-input-box">

              <input
                type="text"
                value={input}
                placeholder={
                  step === "notes"
                    ? "Type notes or 'skip'..."
                    : "Type here..."
                }
                onChange={e =>
                  setInput(
                    e.target.value
                  )
                }
                onKeyDown={e => {
                  if (
                    e.key === "Enter"
                  ) {
                    handleTextInput();
                  }
                }}
              />

              <button
                onClick={
                  handleTextInput
                }
              >
                ➤
              </button>

            </div>
          )}

        </div>
      )}
    </>
  );
}